import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap"
import { getJobApplication } from "store/actions/jobApplicationAction"
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"

const JobApplication = () => {
  const { loading, jobApplication } = useSelector(state => state.JobApplication)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    getAllData()
  }, [activeTab])

  const getAllData = () => {
    const payload = {
      limit: 100,
      page_number: 1,
      order_by: -1,
      filters: {
        type: activeTab, //0:all,1:New Candidate,2:Experience,3:withdrawn
        keyword: "",
        gender: "",
        status: -1,
        dob_date_range: {},
        date_range: {},
      },
    }

    dispatch(getJobApplication(payload))
  }

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <h4 className="card-title mb-4">Applications</h4>

                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={activeTab === 0 ? "active" : ""}
                      onClick={() => toggleTab(0)}
                    >
                      All
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === 1 ? "active" : ""}
                      onClick={() => toggleTab(1)}
                    >
                      New Candidates
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === 2 ? "active" : ""}
                      onClick={() => toggleTab(2)}
                    >
                      Experience
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === 3 ? "active" : ""}
                      onClick={() => toggleTab(3)}
                    >
                      Withdrawn
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col xl="12">
                <Card className="user_personal_info mt-3">
                  <CardBody>
                    {loading && jobApplication.length === 0 ? (
                      <p>No data found</p>
                    ) : (
                      <Table className="table mb-0" hover>
                        <thead className="table-light full_th">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("National Id")}</th>
                            <th>{t("First Name")}</th>
                            <th>{t("Middle Name")}</th>
                            <th>{t("Last Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Phone Number")}</th>
                            <th>{t("DOB")}</th>
                            <th>{t("Gender")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {jobApplication?.map((item, index) => (
                            <tr
                              key={index}
                              className="cursor-pointer"
                              onClick={() =>
                                navigate(
                                  `/application-details?uuid=${item.uuid}`
                                )
                              }
                            >
                              <th scope="row">{index + 1}</th>
                              <td>{item?.national_id}</td>
                              <td>{item?.first_name}</td>
                              <td>{item?.middle_name || "-"}</td>
                              <td>{item?.last_name}</td>
                              <td>{item?.email}</td>
                              <td>
                                {item?.phone?.code} {""} {item?.phone?.number}
                              </td>
                              <td>{item?.dob}</td>
                              <td className="text-capitalize">
                                {item?.gender}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  )
}

export default JobApplication
